exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table {\n    font-size: 0.7em;\n}\n.table th {\n    text-align: center;\n}\n\n.padding-left {\n    padding-left: 3px;\n}\n\n.center {\n    text-align: center;\n}\n\n.small-button {\n  font-size: 0.7em;\n}\n\n.search-span{\n    display:block;\n    width:100%;\n    border-top: 1px solid #808080;\n}\n.cardWidth {\n  width: 49em;\n}\n\n.overlay {\n  position: fixed; /* Sit on top of the page content */\n  width: 100%; /* Full width (cover the whole page) */\n  height: 100%; /* Full height (cover the whole page) */\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0,0,0,0.2); /* Black background with opacity */\n  z-index: 1; /* Specify a stack order in case you're using a different order for other elements */\n}\n@media (max-width: 768px) {\n  .cardWidth {\n    width:  26.2em;\n  }\n  .filterPadding {\n    padding: 20px;\n  }\n}\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/orders/search/search.component.css
// module id = ../../../../../src/app/orders/search/search.component.css
// module chunks = main